// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   WorkspaceList.css — shared styles for Drafts,
   Templates, and Scheduled pages
   ===================================================== */

.workspace-list-page {
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 16px 48px;
  font-family: inherit;
}

/* ── Header ─────────────────────────────────────────── */
.workspace-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 12px;
}

.workspace-list-header h2 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* ── New / action button ─────────────────────────────── */
.workspace-new-btn {
  display: inline-flex;
  align-items: center;
  padding: 7px 14px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #fff;
  background: var(--accent-primary);
  border: none;
  cursor: pointer;
}

.workspace-new-btn:hover {
  opacity: 0.85;
  color: #fff;
  text-decoration: none;
}

/* ── States ──────────────────────────────────────────── */
.workspace-error {
  padding: 12px 16px;
  background: var(--error-bg);
  border: 1px solid var(--error-border, var(--error-color));
  border-radius: 6px;
  color: var(--error-color);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.9rem;
}

.workspace-error button {
  margin-left: auto;
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 0.8rem;
}

.workspace-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 48px 24px;
  text-align: center;
  color: var(--text-secondary);
}

/* ── Item list ───────────────────────────────────────── */
.workspace-item-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.workspace-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  transition: border-color 0.15s;
}

.workspace-item:hover {
  border-color: var(--accent-primary);
}

.workspace-item--posted {
  opacity: 0.65;
}

.workspace-item--cancelled {
  opacity: 0.5;
}

/* ── Item info ───────────────────────────────────────── */
.workspace-item-info {
  flex: 1 1;
  min-width: 0;
  cursor: pointer;
}

.workspace-item-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.workspace-item-title em {
  color: var(--text-tertiary);
  font-style: italic;
}

.workspace-item-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

/* ── Actions ─────────────────────────────────────────── */
.workspace-item-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.workspace-action-btn {
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-primary);
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}

.workspace-action-btn:hover:not(:disabled) {
  background: var(--hover-bg);
}

.workspace-action-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.workspace-delete-btn {
  color: var(--error-color);
  border-color: var(--error-border, var(--error-color));
}

.workspace-delete-btn:hover:not(:disabled) {
  background: var(--error-bg);
}

/* ── Status badges ───────────────────────────────────── */
.workspace-status-badge {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* pending = accent-primary (interactive/future action)
   posting = accent-secondary (in-flight/processing)
   posted  = success-color
   failed  = error-color
   cancelled = text-secondary (muted, no action needed) */
.workspace-status--pending  { background: var(--accent-color-faded);  color: var(--accent-primary); }
.workspace-status--posting  { background: var(--hover-bg);             color: var(--accent-secondary); }
.workspace-status--posted   { background: var(--hover-bg); color: var(--success-color); }
.workspace-status--failed   { background: var(--error-bg);             color: var(--error-color); }
.workspace-status--cancelled{ background: var(--hover-bg);             color: var(--text-secondary); }

.workspace-error-msg {
  color: var(--error-color);
  cursor: help;
}

/* ── Reschedule modal ────────────────────────────────── */
.workspace-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--overlay-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.workspace-modal {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 24px 28px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.workspace-modal h3 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--text-primary);
}

.workspace-datetime-input {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--input-bg);
  color: var(--input-text);
  font-size: 0.9rem;
  width: 100%;
  box-sizing: border-box;
}

.workspace-modal-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* ── Responsive ──────────────────────────────────────── */
@media (max-width: 540px) {
  .workspace-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .workspace-item-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .workspace-list-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WorkspaceList.css"],"names":[],"mappings":"AAAA;;;0DAG0D;;AAE1D;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,yDAAyD;EACzD,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;yDAIyD;AACzD,8BAA8B,qCAAqC,GAAG,4BAA4B,EAAE;AACpG,8BAA8B,2BAA2B,cAAc,8BAA8B,EAAE;AACvG,8BAA8B,2BAA2B,EAAE,2BAA2B,EAAE;AACxF,8BAA8B,2BAA2B,cAAc,yBAAyB,EAAE;AAClG,8BAA8B,2BAA2B,cAAc,4BAA4B,EAAE;;AAErG;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* =====================================================\r\n   WorkspaceList.css — shared styles for Drafts,\r\n   Templates, and Scheduled pages\r\n   ===================================================== */\r\n\r\n.workspace-list-page {\r\n  max-width: 760px;\r\n  margin: 0 auto;\r\n  padding: 24px 16px 48px;\r\n  font-family: inherit;\r\n}\r\n\r\n/* ── Header ─────────────────────────────────────────── */\r\n.workspace-list-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 20px;\r\n  gap: 12px;\r\n}\r\n\r\n.workspace-list-header h2 {\r\n  margin: 0;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* ── New / action button ─────────────────────────────── */\r\n.workspace-new-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 7px 14px;\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  background: var(--accent-primary);\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.workspace-new-btn:hover {\r\n  opacity: 0.85;\r\n  color: #fff;\r\n  text-decoration: none;\r\n}\r\n\r\n/* ── States ──────────────────────────────────────────── */\r\n.workspace-error {\r\n  padding: 12px 16px;\r\n  background: var(--error-bg);\r\n  border: 1px solid var(--error-border, var(--error-color));\r\n  border-radius: 6px;\r\n  color: var(--error-color);\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.workspace-error button {\r\n  margin-left: auto;\r\n  padding: 4px 10px;\r\n  border-radius: 4px;\r\n  border: 1px solid currentColor;\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.workspace-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 48px 24px;\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ── Item list ───────────────────────────────────────── */\r\n.workspace-item-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.workspace-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 14px 16px;\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.workspace-item:hover {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.workspace-item--posted {\r\n  opacity: 0.65;\r\n}\r\n\r\n.workspace-item--cancelled {\r\n  opacity: 0.5;\r\n}\r\n\r\n/* ── Item info ───────────────────────────────────────── */\r\n.workspace-item-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.workspace-item-title {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.workspace-item-title em {\r\n  color: var(--text-tertiary);\r\n  font-style: italic;\r\n}\r\n\r\n.workspace-item-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ── Actions ─────────────────────────────────────────── */\r\n.workspace-item-actions {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.workspace-action-btn {\r\n  padding: 5px 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid var(--border-color);\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition: background 0.15s, color 0.15s;\r\n}\r\n\r\n.workspace-action-btn:hover:not(:disabled) {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.workspace-action-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n.workspace-delete-btn {\r\n  color: var(--error-color);\r\n  border-color: var(--error-border, var(--error-color));\r\n}\r\n\r\n.workspace-delete-btn:hover:not(:disabled) {\r\n  background: var(--error-bg);\r\n}\r\n\r\n/* ── Status badges ───────────────────────────────────── */\r\n.workspace-status-badge {\r\n  display: inline-block;\r\n  padding: 2px 7px;\r\n  border-radius: 10px;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n/* pending = accent-primary (interactive/future action)\r\n   posting = accent-secondary (in-flight/processing)\r\n   posted  = success-color\r\n   failed  = error-color\r\n   cancelled = text-secondary (muted, no action needed) */\r\n.workspace-status--pending  { background: var(--accent-color-faded);  color: var(--accent-primary); }\r\n.workspace-status--posting  { background: var(--hover-bg);             color: var(--accent-secondary); }\r\n.workspace-status--posted   { background: var(--hover-bg); color: var(--success-color); }\r\n.workspace-status--failed   { background: var(--error-bg);             color: var(--error-color); }\r\n.workspace-status--cancelled{ background: var(--hover-bg);             color: var(--text-secondary); }\r\n\r\n.workspace-error-msg {\r\n  color: var(--error-color);\r\n  cursor: help;\r\n}\r\n\r\n/* ── Reschedule modal ────────────────────────────────── */\r\n.workspace-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: var(--overlay-bg);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.workspace-modal {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  padding: 24px 28px;\r\n  min-width: 300px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.workspace-modal h3 {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.workspace-datetime-input {\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  font-size: 0.9rem;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.workspace-modal-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* ── Responsive ──────────────────────────────────────── */\r\n@media (max-width: 540px) {\r\n  .workspace-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .workspace-item-actions {\r\n    width: 100%;\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .workspace-list-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
